<app-header (toggleSidebarHandler)="isSidebarShown = $event" #header></app-header>


<div class="">
  <div class="mini-sidebar" [ngClass]="{'shown': isSidebarShown}">
    <div class="mini-navbar">
      <mat-nav-list class="menu-list">
        <ng-container  *ngFor="let menus of roleMenus; let i = index;">
            <mat-nav-list-item *ngIf="checkItem(menus,menus.roleMenuList)" class="menu-item" 
              (click)="drawerToggle(menus.roleMenuList);makeActive(menus);"
              [ngClass]="{'active-menu': activeMenuIndex == i}" >
                <a class="menu-link" #tooltip="matTooltip" matTooltipClass="right" matTooltip={{menus.menuName}}
                  matTooltipPosition="right"     >
                  <img src="{{menus.menuIocn}}" [alt]="menus.menuName">
                  <span class="menu-name">{{menus.menuName}} </span>
                </a>
            </mat-nav-list-item>
        </ng-container>
      </mat-nav-list>
    </div>
  </div>

  <mat-drawer-container class="example-container main-container" autosize>

    <mat-drawer #drawer mode="side" class="example-sidenav">
      <!-- opened -->
  <!-- <button class="fa fa-bars" (click)="drawer.close()" mat-icon-button>
    <i class="fas fa-times"></i>
  </button> -->

  <button mat-icon-button class="toggle-btn d-block" (click)="drawer.close()">
    <mat-icon>menu</mat-icon>
  </button>
     <div class="sub-menu">
        <mat-nav-list class="menu-list">
          <mat-nav-list-item class="menu-item" *ngFor="let subMenu of menuData">
            <a *ngIf="subMenu.isActive" class="menu-link" #tooltip="matTooltip" matTooltip="{{subMenu.menuName}}" matTooltipClass="right"
              matTooltipPosition="right" [class.active]="isActive(subMenu.menuParameter)"
              [routerLink]="subMenu.menuParameter" (click)="toggleSubMenu()" >
              <span class="menu-name">{{subMenu.menuName}}</span>
            </a>
          </mat-nav-list-item>
        </mat-nav-list>
      </div>
    </mat-drawer>


    <div class="example-sidenav-content">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-container>
</div>
